import {InjectionToken} from '@angular/core';

export interface GrowlConfig {
  location: 'tr' | 'tl' | 'br' | 'bl' | 'tc' | 'bc';
}

export const GROWL_CONFIG_TOKEN = new InjectionToken<GrowlConfig>('GrowlConfigToken');
